export default __webpack_public_path__ + "f263ab5c6734cc8a97b72b5c2757ff91.svg";